import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Inset } from 'syf-component-library/ui/spacing';
import { useTranslation } from 'react-i18next';
import { ErrorDescription, ErrorImage, ErrorImageInset, ErrorMessageContainer, ErrorTitle } from './subcomponents';
import { useGetImages } from '../hooks';
const ErrorScreen = ({ id, errorUrl, errorTitle, errorDescription }) => {
    const { t } = useTranslation();
    const { technicalErrorCat } = useGetImages();
    const errorSrc = errorUrl || technicalErrorCat;
    const title = errorTitle || t('core.errorMessages.havingTrouble');
    const description = errorDescription || t('core.errorMessages.tryAgainLater');
    return (_jsxs(ErrorMessageContainer, { id: id, top: "xxlarge", bottom: "large", "data-cy": "status-message-container", children: [errorSrc && (_jsx(ErrorImageInset, { bottom: "xlarge", children: _jsx(ErrorImage, { src: errorSrc, alt: "error-image" }) })), _jsx(Inset, { bottom: "large", children: _jsx(ErrorTitle, { weight: "bold", "data-testid": "apierrorscreen-title", children: title }) }), _jsx(ErrorDescription, { as: "p", "data-testid": "apierrorscreen-description", children: description })] }));
};
export { ErrorScreen };
